import { Link } from "react-router-dom";

export const faqConfig = {
	'Learn More About Violerts': [
		{
			question: 'What is Violerts?',
			answer: 'Violerts is a property compliance monitoring tool that provides real-time alerts on complaints, violations, and work applications related to your property. It also delivers detailed property reports to keep you informed.',	
		},
		{
			question: 'Where does Violerts collect property compliance data from?',
			answer: 'Violerts gathers property data directly from official NYC agencies such as Department of Buildings [DOB], Housing Preservation and Development [HPD], Fire Department of New York [FDNY], Department of Transportation [NYC DOT], and even New York State databases.',
		},
		{
			question: 'Can I search for any property on Violerts?',
			answer: 'Property searches on Violerts are limited to the New York City Metropolitan Area, including Manhattan, Queens, Brooklyn, the Bronx, and Staten Island.',	
		},
		{
			question: 'What if I search for a property in NYC and data is unavailable?',
			answer: 'If you encounter an error while searching for a NYC property, please report the missing property using the button on the page or contact us via the chatbot. Our team will investigate the issue and provide an update once it is resolved.',	
		},
	],
	'Learn More About Property Alerts and Notifications': [
		{
			question: 'What types of alerts will I receive?',
			answer: 'You will receive real-time alerts in your portfolio via email when Violerts detects new violations, complaints, or work.',
		},
		{
			question: 'Can I sign up for notifications to keep track of any changes in my property?',
			answer: 'You will be able to receive notifications when Violerts detects any change in violations, complaints, or work orders.',
		},
		{
			question: 'How do I set up and manage property alert notifications?',
			answer: 'After setting up an account, you can add properties to your portfolio by clicking the "Add Property" button on the property search page or within your dashboard. Once added, you can manage notifications from the Notifications Settings section in the your portfolio, where you can customize alert frequency and preferences for each property.',
		},
	],
	'Learn More About My Account': [
		{
			question: 'How do I create an account?',
			answer: (
				<span>
					You can create a Violerts account by clicking <Link to="/sign-up">Sign Up</Link> under the profile icon on the upper right corner of the homepage or dashboard. From there, please proceed to provide your email, name, password, and phone number.
				</span>
			),
		},
		{
			question: 'Is my data secure with Violerts?',
			answer: (
				<span>
				Yes! Violerts takes your privacy seriously and uses industry-standard encryption to protect your information including emails, phone numbers and payment details For more details, please review our <Link to="/use-policy">Privacy Policy</Link>.
				</span>
			),
		},
	],
	'Learn More About Support & Contact': [
		{
			question: 'How can I contact Violerts for support?',
			answer: 'The Violerts team is here to help! You can reach us through the chatbot in the bottom right corner of the page, email us at admin@violerts.com, or call us at (212) 401-6011. Whether you need help adding a property to your portfolio, have questions about using Violerts, or want to report an issue, our team is ready to assist you.',
		},
	],
	'Dashboard Glossary': [
		{
			question: 'FAR',
			answer: `
FAR, or Floor Area Ratio, is the ratio of a building’s total floor area to the size of its lot, regulating how much floor space can be developed. It is calculated by dividing the total gross floor area of the building by the area of the lot it occupies.\n
The FAR regulation differs between commercial and residential zones. Commercial FAR typically allows for larger buildings with greater density, while residential FAR is typically more restrictive to maintain livability.
			`,
		},
		{
			question: 'Zoning District',
			answer: `
A zoning district defines how land can be used in a given area. In NYC, zoning districts are categorized in three main categories: Residential (R), Commercial (C), and Manufacturing (M). Each district includes numerical designations (like R6 or C2-4) that determine building types, density, and use. Within each lot, there may be one or more zoning designations assigned—this is where the “Zoning 1/2” and “Zoning 3/4” entries on the dashboard come in.\n
Zoning 1/2 means the lot is split between two zoning districts.\n
Zoning 3/4 means it spans four zoning designations.\n
This affects how much of the property can be developed under each zoning rule and often requires more complex planning or filings. Some zoning districts also have overlays (like Commercial Overlay 1 or 2) or special purpose districts with additional restrictions or incentives.
			`,
		},
		{
			question: 'Land Use',
			answer: `
Land use refers to the official classification of how a property is used, based on NYC’s zoning and tax assessment categories. Unlike zoning districts, which regulate what can be built, land use codes indicate how a property is currently used—which is why you’ll often see numeric designations on the dashboard. \n
These numeric codes correspond to specific use categories assigned by the NYC Department of City Planning. For example: \n
01 – One- and Two-Family Buildings \n
02 – Multi-Family Walk-Up Buildings \n
04 – Mixed Residential & Commercial \n
05 – Commercial & Office Buildings \n
07 – Industrial & Manufacturing \n
09 – Open Space & Outdoor Recreation \n
11 – Educational Facilities 
			`,
		},
		{
			question: 'Commercial Overlay',
			answer: `
A commercial overlay is a zoning designation that permits limited commercial uses—such as retail stores, restaurants, or offices—within primarily residential areas. These overlays are mapped onto residential zoning districts to support local businesses while preserving the character of the neighborhood. \n
On the dashboard, you'll see these labeled as Commercial Overlay 1 (C1) and Commercial Overlay 2 (C2): \n
C1 overlays allow low-intensity commercial uses like small service businesses, dry cleaners, and corner stores. \n
C2 overlays allow a broader range of commercial uses, including restaurants and repair shops, with slightly less restriction. \n
The rules also affect signage, building design, and how close businesses can be to residential properties. 
			`,
		},
		{
			question: 'Building Class',
			answer: `

A building class categorizes structures based on their use and occupancy, which affects zoning regulations, tax assessments, and compliance requirements. In NYC, building classes are typically divided into residential (Class A and B), commercial, industrial, and special use categories. \n
Class A includes standard residential buildings like apartment complexes and one- to two-family homes. \n
Class B includes transient residences, such as hotels and dormitories. \n
Commercial classes cover office buildings, retail stores, and restaurants. \n
Industrial classes include factories and warehouses. \n
Special use classes may include government buildings, schools, and hospitals. 
			`,
		},
		{
			question: 'HPD Multiple Dwelling',
			answer: `HPD, or NYC’s Department of Housing Preservation & Development, requires residential property owners to register as ‘multiple dwelling’ if the property contains 3 or more residential units.`,
		},
		{
			question: 'Landmark',
			answer: `
A structure, district, or site officially recognized by the LPC (Landmarks Preservation Commission) for its historical or architectural significance. With an LPC designation, a building is protected from unapproved alterations or demolition. \n
The Violerts dashboard breaks out landmark details by architect, primary style, building material, and original use.  
			`,
		},
		{
			question: 'OER',
			answer: `
OER, or the NYC Office of Environmental Remediation, oversees programs that manage brownfield cleanup and environmental protection initiatives.
			`,
		},
		{
			question: 'SRO Restricted',
			answer: `
An SRO, or Single Room Occupancy, restriction limits a buildings conversion to another use without city approval, typically to preserve affordable housing.  
			`,
		},
		{
			question: 'Local Laws',
			answer: `
Local laws are city-specific regulations that govern building safety, energy efficiency, and compliance. Many apply citywide, while others are tailored to specific zoning districts, occupancy types, or building classifications. These laws often reflect local priorities, like sustainability or neighborhood preservation, and can vary depending on location.
			`,
		},
		{
			question: 'DOB Complaint vs. DOB Violation',
			answer: `
A DOB complaint is a reported issue that may or may not lead to enforcement action. A DOB violation is an official finding of non-compliance that will lead to enforcement action.
			`,
		},
		{
			question: 'Full Historic Information Request',
			answer: `
A full historic information request is made for comprehensive DOB records including permits, violations, and certificates of occupancy. This is often used in due diligence.  
			`,
		},
		{
			question: 'ACRIS',
			answer: `
ACRIS, or the Automated City Register Information System, provides access to legal documents recorded against a property—such as deeds, mortgages, and other transactions. On the dashboard this appears as ACRIS Legals, ACRIS Documents, and ACRIS Sales and Transfers.
			`,
		},
		{
			question: 'DOB BIS vs. DOB Now',
			answer: `
DOB BIS, or Building Information System, is the older system for viewing permits, complaints, and violations with the DOB. DOB Now is the modernized portal for filings, payments, and permit applications. 
			`,
		},
		{
			question: 'Open Data',
			answer: `
NYC Open Data is free public data published by a broader range of public databases.
			`,
		},
		{
			question: 'CO vs. TCO',
			answer: `
A CO, or Certificate of Occupancy, is a permanent document issued by the DOB confirming that a building complies with all applicable codes and is safe for its intended use. A TCO, or Temporary Certificate of Occupancy, allows for partial or temporary occupancy while final approvals or outstanding work are completed. TCOs must be renewed periodically until a full CO is obtained.
			`,
		},
		{
			question: 'TUP',
			answer: `
A TUP, or Temporary Use Permit, is issued to allow short-term activities or occupancy that would not normally comply with zoning regulations
			`,
		},
		{
			question: 'Public Assembly',
			answer: `
Public Assembly is a use classification requiring special permits for spaces where 75+ people gather, such as theaters, restaurants, or event halls
			`,
		},
		{
			question: 'Temporary Public Assembly',
			answer: `
Temporary Public Assembly is a short-term permit required for gatherings of 75+ people in spaces not already approved for public assembly, such as pop-ups, temporary events, or seasonal installations.
			`,
		},
		{
			question: 'Post Amendment Approval',
			answer: `
A Post Amendment Approval is a DOB filing used to revise or update an already approved set of plans or permits. It’s typically required when changes are made to the scope, layout, or design after the initial approval. 
			`,
		},
		{
			question: 'Tax Lien Sale',
			answer: `
Tax Lien Sale is a process where the city sells unpaid property tax debts to private investors who can then collect payments or initiate foreclosure.
			`,
		},
		{
			question: 'CityPay Ticket',
			answer: `
CityPay is NYC’s online platform for paying various fines including DOB, FDNY, and ECB violations.
			`,
		},
		{
			question: 'Docket Book',
			answer: `
A docket book is a historical record of building transactions, often used for legal and research purposes. Copies can be requested from the Department of Buildings (DOB) borough offices or through a Full Historic Information Request.
			`,
		},
		{
			question: 'Energy Efficiency',
			answer: `
Energy efficiency is the measure of how effectively a building uses energy and is often regulated under NYC’s Local Law 97 and other sustainability laws. Energy efficiency ratings are meant to lower carbon emissions in buildings.
			`,
		},
	],
};



export const landingPageFaqConfig = [
	{
		question: 'What is Violerts?',
		answer: 'Violerts is a property compliance monitoring tool that provides real-time alerts on complaints, violations, and work applications related to your property. It also delivers detailed property reports to keep you informed.',	
	},
	{
		question: 'What types of alerts will I receive?',
		answer: 'You will receive real-time alerts in your portfolio via email when Violerts detects new violations, complaints, or work.',
	},
	{
		question: 'Can I sign up for notifications to keep track of any changes in my property?',
		answer: 'You will be able to receive notifications when Violerts detects any change in violations, complaints, or work orders.',
	},
]